import { CommonModule } from "@angular/common";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CorpLoadingComponent } from "@corporate-tailwind/component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { CorpTranslateService } from "@corporate-tailwind/translation";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ItsMeEmailValidationComponent } from "../email-validation/itsme-email-validation.component";

@Component({
    selector: 'itsme-email-ask-validation',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, CorpLoadingComponent, ItsMeEmailValidationComponent],
    templateUrl: './itsme-email-ask-validation.component.html',
    animations: [ ]
})
export class ItsMeEmailAskValidationComponent implements OnInit, OnDestroy {
form: FormGroup | null = null;
answer: string = '';
isSendMail: boolean = false;

    constructor(
        public _orderWizardService: OrderWizardService,
        private _translateService: TranslateService,
        private _corpTranslateService: CorpTranslateService
    ) {
        this.form = this._orderWizardService.formGroup;
    }


    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }

    onChoiceChange(response: boolean) {
        this.isSendMail = !response;

        this._orderWizardService.setValue(x=>x.step03?.customerDto?.isAskMailConfirmed, !response);
    }

}